import { defineStore } from 'pinia'

const STORAGE_KEY_PREFIX = 'columnPrefs:'

export const useColumnPrefsStore = defineStore('columnPrefs', {
  state: () => ({
    hiddenColumnIDs: {} as Record<string, string[]>,
  }),

  actions: {
    loadPrefs(tableId: string, defaultHiddenIDs: string[] = []) {
      if (this.hiddenColumnIDs[tableId] !== undefined) return
      const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${tableId}`)
      // No stored value yet — this is the user's first visit to this table,
      // so apply the table's default hidden columns instead of showing everything.
      // Note: defaultHiddenIDs is stored by reference — every call site currently
      // passes a fresh array literal, but a caller passing a shared/mutated array
      // in the future would leak that mutation into store state.
      if (stored === null) {
        this.hiddenColumnIDs[tableId] = defaultHiddenIDs
        return
      }
      try {
        const parsed: unknown = JSON.parse(stored)
        if (Array.isArray(parsed)) {
          this.hiddenColumnIDs[tableId] = (parsed as unknown[]).filter(
            (x): x is string => typeof x === 'string'
          )
          return
        }
      } catch {}
      this.hiddenColumnIDs[tableId] = defaultHiddenIDs
    },

    toggleColumn(tableId: string, columnID: string) {
      const current = this.hiddenColumnIDs[tableId] ?? []
      const idx = current.indexOf(columnID)
      this.hiddenColumnIDs[tableId] =
        idx === -1 ? [...current, columnID] : current.filter((x) => x !== columnID)
      localStorage.setItem(
        `${STORAGE_KEY_PREFIX}${tableId}`,
        JSON.stringify(this.hiddenColumnIDs[tableId])
      )
    },
  },
})
